<template>
  <div class="machines-show-modem container-fluid">
    <template v-if="machine && machine.modem">
      <div class="d-flex align-items-center">
        <h2 class="page-heading mr-auto">Модем {{machine.modem.number}}</h2>
        <button class="btn btn-sm btn-outline-danger mr-2" @click="unbindModem">
          Отвязать
        </button>
        <router-link
          v-if="$root.checkPermission('web_modems_edit')"
          :to="`/modems/${machine.modem.uid}`"
          class="btn btn-sm btn-outline-light"
          v-text="`Модем ${machine.modem.uid}`"
        />
      </div>

      <hr class="mt-0">

      <div class="machines-show-modem-summary">
        <div class="row align-items-center">
          <div class="col-md">
            <div class="row align-items-center mb-3">
              <div class="col-sm">
                <div class="media align-items-center">
                  <img class="modem-svg-icon d-flex mr-3" src="../../../../img/machine-features/modem.svg">
                  <div class="media-body">
                    <p class="mb-1"><strong>Модем:</strong> <span class="text-success">подключен</span></p>
                    <p class="mb-1"><strong>Версия ПО:</strong> {{machine.modem.software_version}}</p>
                    <p class="mb-1"><strong>Шина MDB:</strong><!--machine.modem.mdb_test-->
                      <span :class="machine.is_online ? 'text-success' : 'text-danger'">
                        {{machine.is_online ? 'норма' : 'ошибка'}}
                      </span>
                    </p>
                    <p class="mb-1"><strong>ICCID:</strong> {{machine.modem.iccid}}</p>
                    <p class="mb-1"><strong>IMSI:</strong> {{machine.modem.imsi}}</p>
                    <p class="mb-1"><strong>Оператор:</strong> {{operator}}</p>
                    <p class="mb-1"><strong>Уровень сигнала:</strong> {{signal}}</p>
                  </div>
                </div>
              </div>
              <div class="col-sm">
                <btn-action @click="() => sendCommand('reboot', null)" class="btn btn-outline-primary btn-block">
                  Перезапустить модем
                </btn-action>
              </div>
            </div>
          </div>
          <div class="col-md">
            <div class="row align-items-end mb-3">
              <div class="col-sm">
                <h3>Прошивка модема</h3>
                <form ref="firmware">
                  <label class="btn btn-file btn-outline-danger m-0">
                    <input @change="onFileChange($event, 'firmware')" type="file"/>
                    Выберите файл
                  </label>
                  <span class="ml-1">{{firmwareName}}</span>
                </form>
              </div>
              <div class="col-sm">
                <btn-action @click="() => uploadFile('firmware')" :disabled="!firmware" class="btn btn-outline-primary btn-block">
                  Загрузить
                </btn-action>
              </div>
            </div>
            <div class="row align-items-end mb-3">
              <div class="col-sm">
                <h3>Конфигурационный файл модема (cfgprg)</h3>
                <form ref="cfgprg">
                  <label class="btn btn-file btn-outline-danger m-0">
                    <input @change="onFileChange($event, 'cfgprg')" type="file"/>
                    Выберите файл
                  </label>
                  <span class="ml-1">{{cfgprgName}}</span>
                </form>
              </div>
              <div class="col-sm">
                <btn-action @click="() => uploadFile('cfgprg')" :disabled="!cfgprg" class="btn btn-outline-primary btn-block">
                  Загрузить
                </btn-action>
              </div>
            </div>
            <div class="row align-items-end mb-3">
              <div class="col-sm">
                <h3>Конфигурационный файл автомата (evaprg)</h3>
                <form ref="evaprg">
                  <label class="btn btn-file btn-outline-danger m-0">
                    <input @change="onFileChange($event, 'evaprg')" type="file"/>
                    Выберите файл
                  </label>
                  <span class="ml-1">{{evaprgName}}</span>
                </form>
              </div>
              <div class="col-sm">
                <btn-action @click="() => uploadFile('evaprg')" :disabled="!evaprg" class="btn btn-outline-primary btn-block">
                  Загрузить
                </btn-action>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr>

      <div class="machines-show-modem-details row">
        <div class="col-md-6">
          <!-- <div class="row align-items-center mb-3">
            <div class="col-sm">
              <div class="media align-items-center">
                <img class="modem-svg-icon d-flex mr-3" src="../../../../img/machine-features/bluetooth.svg">
                <div class="media-body">Bluetooth:
                  <span :class="machine.modem.bluetooth ? 'text-danger' : ''">
                    {{machine.modem.bluetooth ? 'включен' : 'выключен' }}
                  </span>
                </div>
              </div>
            </div>
          </div> -->

          <!-- <div class="row align-items-center mb-3">
            <div class="col-sm">
              <div class="media align-items-center">
                <img class="modem-svg-icon d-flex mr-3" src="../../../../img/machine-features/door.svg">
                <div class="media-body">Дверь выд. тов.:
                  <span :class="machine.modem.relay ? 'text-success' : 'text-danger'">
                    {{machine.modem.relay ? 'заблокирована' : 'разблокирована'}}
                  </span>
                </div>
              </div>
            </div>
            <div class="col-sm">
              <btn-action @click="() => sendCommand('man','relay: ' + (machine.modem.relay ? 0 : 1) + ',0,0' )"
                class="btn btn-outline-light btn-block">
                {{machine.modem.relay ? 'Разблокировать' : 'Заблокировать'}}
              </btn-action>
            </div>
          </div> -->

          <!-- <div class="row align-items-center mb-3">
            <div class="col-sm">
              <div class="media align-items-center">
                <img class="modem-svg-icon d-flex mr-3" src="../../../../img/machine-features/camera.svg">
                <div class="media-body">Камера:
                  <span :class="{'text-success': machine.modem.camera}">
                    {{machine.modem.camera ? 'подключена' : 'отключена'}}
                  </span>
                </div>
              </div>
            </div>
            <div class="col-sm">
              <btn-action
                @click="execCamCommand"
                class="btn btn-outline-light btn-block"
                v-text="'Сделать снимок'"
                :disabled="machine.modem.made_in === 'spain'"
              />
            </div>
          </div> -->

          <!-- <div class="row align-items-center mb-3">
            <div class="col-sm">
              <div class="media align-items-center">
                <img class="modem-svg-icon d-flex mr-3" src="../../../../img/machine-features/mike.svg">
                <div class="media-body">Микрофон</div>
              </div>
            </div>
            <div class="col-sm">
              <btn-action
                @click="execMicCommand"
                class="btn btn-outline-light btn-block"
                v-text="'Сделать запись'"
                :disabled="machine.modem.made_in === 'spain'"
              />
            </div>
          </div> -->

          <!-- <div class="row align-items-center mb-3">
            <div class="col-sm">
              <div class="media align-items-center">
                <img class="modem-svg-icon d-flex mr-3" src="../../../../img/machine-features/electro.svg">
                <div class="media-body">Электропитание:
                  <span :class="machine.modem.electricity ? 'text-success' : 'text-danger'">
                    {{machine.modem.electricity ? 'есть' : 'нет'}}
                  </span>
                </div>
              </div>
            </div>
            <div class="col-sm">
              <btn-action @click="() => power()"
                          :disabled="machine.modem.battery ? machine.modem.battery <= 30 : true"
                class="btn btn-outline-light btn-block">
                {{machine.modem.electricity ? 'Выключить' : 'Включить' }}
              </btn-action>
            </div>
          </div> -->

          <div class="row align-items-center mb-3" v-if="machine.modem.made_in === 'spain'">
            <div class="col-sm"></div>
            <div class="col-sm">
              <btn-action @click="() => reboot()"
                          class="btn btn-outline-light btn-block">
                Перезапустить ТА
              </btn-action>
            </div>
          </div>

        </div>
        <div class="col-md-6">
          <button id="btnGroupDrop1" type="button" class="btn btn-outline-danger btn-block dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <font-awesome-icon icon="unlock-alt"/>
            Сбросить пароль
          </button>
          <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
            <button class="dropdown-item" @click="resetPassword(false)">По умолчанию</button>
            <button v-if="$root.checkPermission('admin_access')" class="dropdown-item" @click="resetPassword(true)">Случайный</button>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <h2 class="page-heading">Модем не подключен</h2>
      <div class="form-group">
        <label>ID модема</label>
        <server-select
          v-model="uid"
          endpoint="modems/options"
          label="uid"
          class="modem-select"
        />
      </div>
      <btn-action class="btn btn-primary" @click="save">Сохранить</btn-action>
    </template>
  </div>
</template>

<script>
  import { get } from 'lodash'
  import api from '@/api'
  import BtnAction from '../../../components/btn-action'

  export default {
    components: {BtnAction},
    data () {
      return {
        uid: null,
        firmware: null,
        cfgprg: null,
        evaprg: null,
        validationErrors: {},
      }
    },
    props: {
      id: {
        required: true,
      },
      machine: {
        type: Object,
      },
    },
    computed: {
      firmwareName () {
        if (this.firmware) {
          return this.firmware.name
        } else {
          return 'Файл не выбран'
        }
      },
      cfgprgName () {
        if (this.cfgprg) {
          return this.cfgprg.name
        } else {
          return 'Файл не выбран'
        }
      },
      evaprgName () {
        if (this.evaprg) {
          return this.evaprg.name
        } else {
          return 'Файл не выбран'
        }
      },
      operator () {
        return get(this.machine.modem, 'data.operator', 'Неизвестен')
      },
      signal () {
        return get(this.machine.modem, 'data.signal', '?%')
      },
    },
    methods: {
      save () {
        return api.post(`modems/${this.uid.id}/associate`, {
          machineId: this.id,
        }).then((data) => {
          window.location.reload()
        })
      },
      unbindModem () {
        if (window.confirm('Отвязать модем?')) {
          return api.post(`modems/${this.machine.modem.id}/dissociate`)
            .then(() => {
              window.location.reload()
            })
        }
      },
      resetPassword (random) {
        if (window.confirm('Действительно хотите изменить пароль?')) {
          return api.put(`modems/${this.machine.modem.id}/resetPassword`, {random: random})
        }
      },
      sendCommand (type, data) {
        return api.post(`modems/${this.machine.modem.uid}/commands`, {
          type: type,
          data: data,
        })
      },
      reboot () {
        return api.put(`modems/${this.machine.modem.uid}/commands/reboot`)
      },
      power () {
        let value = this.machine.modem.electricity
        value = this.machine.modem.made_in === 'russia' ? 'power: ' + (value ? 1 : 0) : 'out1: ' + (value ? 0 : 1)
        return this.sendCommand('man', value)
      },
      execCamCommand () {
        return api.post(`modems/${this.machine.modem.uid}/commands/camera`)
          .then(alert.bind(null, 'Команда отправлена.'))
          .catch(alert.bind(null, 'Ошибка. Попробуйте еще раз.'))
      },
      execMicCommand () {
        return api.post(`modems/${this.machine.modem.uid}/commands/microphone`)
          .then(alert.bind(null, 'Команда отправлена.'))
          .catch(alert.bind(null, 'Ошибка. Попробуйте еще раз.'))
      },
      uploadFile (name) {
        const data = new FormData()
        data.append(name, this[name])
        this[name] = undefined
        this.$refs[name].reset()
        return api.post(`modems/${this.machine.modem.id}/upload${name.charAt(0).toUpperCase() + name.slice(1)}`, data, {
          headers: {'content-type': 'multipart/form-data'},
        })
      },
      onFileChange (e, name) {
        const files = e.target.files || e.dataTransfer.files
        if (!files.length) return
        this[name] = files[0]
      },
    },
    asyncComputed: {},
  }
</script>

<style lang="scss">
  @import "boot";
  .modem-svg-icon {
    // https://codepen.io/stilllife00/pen/avXpgJ
    filter: grayscale(100%) brightness(140%) sepia(100%) hue-rotate(120deg) saturate(500%) contrast(.5);
  }
  .machines-show-modem-summary, .machines-show-modem-details {
    .btn {
      max-width: 15em;
    }
  }
  .modem-select {
    max-width: 50em;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/machines/_id/modem.vue